import { h, render } from 'preact'
import { BlogCard } from './BlogCard'

const data = window.globals?.currentBlog?.articles || []
function FeaturedArticles() {
  const featuredArticles = data.slice(0, 3)

  if (!featuredArticles || featuredArticles.length === 0) {
    return <div><p className="paragraph-m">No featured articles found.</p></div>
  }

  return (
    <div className="grow flex flex-col px-margin py-1.5 lg:py-2.5">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-x-0.25 gap-y-1.5 w-full">
        {featuredArticles.map((article, index) => (
          <BlogCard blog={article} key={article.id} dataIndex={index.toString()} />
        ))}
      </div>
    </div>
  )
}

function RenderFeaturedContent() {
  return <FeaturedArticles />
}

function initFeaturedArticles() {
  console.log('init featured articles')
  const container = document.getElementById('featuredArticles')
  if (container && window.globals?.currentBlog?.articles) {
    render(<RenderFeaturedContent />, container)
  } else {
    setTimeout(initFeaturedArticles, 100)
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFeaturedArticles)
} else {
  initFeaturedArticles()
}
